// React
import * as React from 'react';

// Redux
import { connect } from 'react-redux';

// Components
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { Card } from "@material-ui/core";

// Components
import Typography from '@material-ui/core/Typography';

interface State {
  stats: any;
}

interface Props {
  pastColor: string;
  futureColor: string;
  data: any;
}

// const data = [
//   { "name": 'Jours réservés (total)', "Passé": 130, "Futur": 70 },
//   { "name": 'Jours réservés (semaine)', "Passé": 67, "Futur": 51 },
//   { "name": 'Jours réservé (week-end)', "Passé": 63, "Futur": 19 }
//   // { "name": 'Nombre adultes', "Passé": 2000, "Futur": 9800, "Moyenne": 2290 }, => Graph 2
//   // { "name": 'Nombres enfants', "Passé": 2780, "Futur": 3908, "Moyenne": 2000 },
//   // { "name": 'Bénéfices', "Passé": 1890, "Futur": 4800, "Moyenne": 2181 }, => Graph 3
// ];

/**
 * @description Home View
 * @author Lucas Fridez <lucas@fridez.dev>
 * @export
 * @class App
 * @extends {React.Component}
 */
export default connect((state) => state)(class LocationDayChart extends React.Component<Props, State> {

  /**
   * Creates an instance of Home.
   * @author Lucas Fridez <lucas@fridez.dev>
   * @param {*} props
   * @memberof App
   */
  constructor(props: Props) {
    super(props);
    this.state = {
      stats: [
        { "name": 'Jours réservés (total)', "Passé": props.data.total_past, "Futur": props.data.total_futur },
        { "name": 'Jours réservés (semaine)', "Passé": props.data.regular_past, "Futur": props.data.regular_futur },
        { "name": 'Jours réservé (week-end)', "Passé": props.data.weekend_past, "Futur": props.data.weekend_futur }
      ]
    };
  }

  componentWillReceiveProps(props: Props, nextState: State) {
    if (props.data) {
      this.setState({
        stats: [
          { "name": 'Jours réservés (total)', "Passé": props.data.total_past, "Futur": props.data.total_futur },
          { "name": 'Jours réservés (semaine)', "Passé": props.data.regular_past, "Futur": props.data.regular_futur },
          { "name": 'Jours réservé (week-end)', "Passé": props.data.weekend_past, "Futur": props.data.weekend_futur }
        ]
      });
    }
  }

  async componentWillMount() {
    // nothing
  }

  componentDidMount() {
    // nothing
  }

  /**
   * @description Render the HomeView in the Browser
   * @author Lucas Fridez <lucas@fridez.dev>
   * @returns
   * @memberof App
   */
  public render() {

    const { pastColor, futureColor } = this.props;

    return (
      <Card>
        <Typography variant="title" style={{ marginLeft: 10, marginTop: 10 }} gutterBottom={true}>Jours réservés</Typography>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={this.state.stats}
            margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend wrapperStyle={{
              height: 0
            }} />
            <Bar dataKey="Passé" stackId="a" fill={pastColor} />
            <Bar dataKey="Futur" stackId="a" fill={futureColor} />
          </BarChart>
        </ResponsiveContainer>
      </Card>
    );
  }
});



// WEBPACK FOOTER //
// ./src/app/views/Charts/LocationDayChart.tsx